import { DynamicPage, DynamicPageEntity } from "./graphQL";

export const getDynamicPageFromGQResult = (entities?: DynamicPageEntity[]): DynamicPage[] => {
    return (entities ?? [])?.map(({ nid, title, status, className, adminId, graphicElements }) => {
        return {
            nid,
            title,
            status,
            className,
            adminId,
            graphicElements: graphicElements ?? []
        };
    });
};
